import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../caremap/CareMapState';
import { OrganizationsState } from '../organizations/OrganizationsState';
import { useSubscription } from '@meraki-internal/state';
import { NavigationItemList } from './NavigationItemList';
import { NavigationItem } from './NavigationItem';
import { AddCareMapButton } from '../caremap/AddCareMapButton';
import { InviteFriendsButton } from '../referral/InviteFriendsButton';
import { AppPrincipal, isAnonymousViewer } from '../auth/AppPrincipal';
import { Divider } from '../components/Divider';
import { HistoryViewModel } from '../support/HistoryViewModel';
import { DuoClipboardListCheckIcon } from '../theme/Icons';

interface NewUINavigationListProps {
    closeMenuHandler?: () => Promise<void>;
}

export const NewUINavigationList: React.FC<NewUINavigationListProps> = ({ closeMenuHandler  }) => {
    const isAnonymous = isAnonymousViewer(useInstance(AppPrincipal));

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const orgState = useInstance(OrganizationsState);
    useSubscription(() => orgState);

    const history = useInstance(HistoryViewModel);

    // don't show nav, that would direct user to create a personal caremap
    if (orgState.isOrgTeamMember() && !careMapState.getMostRecentCaremap()){
        return null;
    }

    // Button stays visible for non-anonymous, non-org-team-member users.
    // AddCareMapButton handles its own disabled state during intro processing.
    const showAddButton = !orgState.isOrgTeamMember() && !isAnonymous;

    return (
        <NavigationItemList>
            {showAddButton && (
                <>
                    <div style={{margin: 24}}>
                        <AddCareMapButton
                            trackingFrom="side-menu"
                            closeMenu={() => {
                                if (closeMenuHandler){
                                    closeMenuHandler();
                                }
                            }}
                        />
                    </div>
                    <InviteFriendsButton closeMenu={() => {
                        if (closeMenuHandler){
                            closeMenuHandler();
                        }
                    }} />
                    <NavigationItem
                        label="Set Up"
                        data-id="nav-onboarding"
                        icon={<DuoClipboardListCheckIcon />}
                        onClick={async () => {
                            // Let the menu finish sliding shut before routing: the destination page renders
                            // its own menu instance, so navigating unmounts this one and a mid-animation
                            // unmount makes it disappear abruptly instead of closing.
                            if (closeMenuHandler){
                                await closeMenuHandler();
                            }
                            history.push('/setup');
                        }}
                    />
                    <Divider />
                </>
            )}
        </NavigationItemList>
    );
};
